export default (theme) => ({
  root: {
    background: theme.palette.background.default,
    position: 'relative',
  },
});
